export default __webpack_public_path__ + "static/media/F-PUR-03-VRF-Vishakha.4f7dbc8a.DOCX";